import {formatData} from '@/utils/util'
import moment from 'moment'
import unitNumber from '@/utils/unitNumber';

export const batchTableColumns = (isNowWaCustomer) => {
  const wareHouse = [
    {
      title: '仓库编码',
      dataIndex: 'warehouseCode',
      key: 'warehouseCode',
      width: 180,
    },
    {
      title: '仓库名称',
      dataIndex: 'warehouseName',
      key: 'warehouseName',
      width: 180,
    },
  ]
  const attr = isNowWaCustomer?wareHouse:[]
  return [
    ...attr,
    {
      title: '货品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      scopedSlots: { customRender: 'goodsName' },
      width: 200,
    },
    {
      title: '货品编码',
      dataIndex: 'goodsCode',
      key: 'goodsCode',
      ellipsis: true,
      width: 200,
    },
    {
      title: '货主货品编码',
      dataIndex: 'shipperGoodsCode',
      key: 'shipperGoodsCode',
      width: 180,
    },
    {
      title: '批次号',
      dataIndex: 'batchNo',
      key: 'batchNo',
      width: 180,
    },
    {
      title: '默认单位',
      dataIndex: 'defaultUnit',
      key: 'defaultUnit',
      width: 180,
    },
    {
      title: '单位换算率',
      dataIndex: 'conversionRate',
      key: 'conversionRate',
      width: 180,
    },
    {
      title: '在库库存（整单位）',
      dataIndex: 'totalBigUnitAmount',
      key: 'totalBigUnitAmount',
      width: 180,
    },
    {
      title: '在库库存（零单位）',
      dataIndex: 'totalSmallUnitAmount',
      key: 'totalSmallUnitAmount',
      width: 180,
    },
    {
      title: '可用量',
      dataIndex: 'availableAmount',
      key: 'availableAmount',
      width: 180,
    },
    {
      title: '锁定量',
      dataIndex: 'lockedAmount',
      key: 'lockedAmount',
      width: 180,
    },
    {
      title: '冻结量',
      dataIndex: 'frozenAmount',
      key: 'frozenAmount',
      width: 180,
    },
    {
      title: '生产日期',
      dataIndex: 'productDate',
      key: 'productDate',
      customRender: (text, record) => record.batchAttributes?.productDate,
      width: 180,
    },
    {
      title: '到期日期',
      dataIndex: 'expireDate',
      key: 'expireDate',
      customRender: (text, record) => record?.stockExpireDate,
      width: 180,
    },
  ]
}

export const availTableColumns = (isNowWaCustomer) => {
  const wareHouse = [
    {
      title: '仓库编码',
      dataIndex: 'warehouseCode',
      key: 'warehouseCode',
      width: 180,
    },
    {
      title: '仓库名称',
      dataIndex: 'warehouseName',
      key: 'warehouseName',
      width: 180,
    },
  ]
  const attr = isNowWaCustomer?wareHouse:[]
  return [
    ...attr,
    {
      title: '货品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      scopedSlots: { customRender: 'goodsName' },
      width: 200,
    },
    {
      title: '货品编码',
      dataIndex: 'goodsCode',
      key: 'goodsCode',
      ellipsis: true,
      width: 200,
    },
    {
      title: '货主货品编码',
      dataIndex: 'shipperGoodsCode',
      key: 'shipperGoodsCode',
      width: 180,
    },
    {
      title: '默认单位',
      dataIndex: 'defaultUnit',
      key: 'defaultUnit',
      width: 180,
    },
    {
      title: '在库库存（整单位）',
      dataIndex: 'totalBigUnitAmount',
      key: 'totalBigUnitAmount',
      width: 180,
    },
    {
      title: '在库库存（零单位）',
      dataIndex: 'totalSmallUnitAmount',
      key: 'totalSmallUnitAmount',
      width: 180,
    },
    {
      title: '可用量',
      dataIndex: 'availableAmount',
      key: 'availableAmount',
      width: 180,
    },
    {
      title: '锁定量',
      dataIndex: 'lockedAmount',
      key: 'lockedAmount',
      width: 180,
    },
    {
      title: '冻结量',
      dataIndex: 'frozenAmount',
      key: 'frozenAmount',
      width: 180,
    },
  ]
}

// 冻结状态
export const FROZEN_STATUS = {
  FROZEN: '冻结',
  UNFROZEN: '解冻',
}
// 临期预警
export const ALERT_OPTIONS = [
  {
    value: 'FIRST',
    label: '首次预警',
    color: '#FFCE83',
  },
  {
    value: 'SECOND',
    label: '二次预警',
    color: '#FF9D07',
  },
  {
    value: 'STOP_WARNING',
    label: '停止发货预警',
    color: '#F56C6C',
  },
  {
    value: 'STOP',
    label: '停止发货',
    color: '#909399',
  },
  {
    value: 'NORMAL',
    label: '正常',
    color: '#07C160',
  },
];
export const ALERT_ENUM = {
  FIRST: '#FFCE83',
  SECOND: '#FF9D07',
  STOP_WARNING: '#F56C6C',
  STOP: '#909399',
  NORMAL: '#07C160',
}
// 库存状态
export const STOCK_STATUS = {
  NORMAL: '正常',
  IMMINENT: '临期',
  EXPIRED: '已过期',
}

// 费目明细table配置
export const costBreakdownColumns = [
  {
    title: '序号',
    key: 'index',
    dataIndex: 'index',
    scopedSlots: { customRender: "index" },
    width:80,
  },
  {
    title: '费目名称',
    dataIndex: 'costCode',
    key: 'costCode',
  },
  {
    title: '应付金额(元)',
    dataIndex: 'billValue',
    key: 'billValue',
  },
]
// 库存查询(按可用量查询)
export const AcailableSearchFiled= [
  {
    label:'仓库',
    name:'warehouseCode',
    custom:true
  },
  {
    label:'货品编码',
    name:'goodsCode',
    type:'input',
    prop:{
      placeholder: '请输入货品编码',
      maxLength:100
    }
  },
  {
    label:'货品名称',
    name:'goodsName',
    type:'input',
    prop:{
      placeholder: '请输入货品名称',
      maxLength:100
    },
  },
]

// 库存查询(按批量查询)
export const BatchSearchFiled= [
  {
    label:'仓库',
    name:'warehouseCode',
    custom:true
  },
  {
    label:'货品编码',
    name:'goodsCode',
    type:'input',
    prop:{
      placeholder: '请输入货品编码',
      maxLength:100
    }
  },
  {
    label:'货品名称',
    name:'goodsName',
    type:'input',
    prop:{
      placeholder: '请输入货品名称',
      maxLength:100
    },
  },
  {
    label:'批次',
    name:'batchNo',
    type:'input',
    prop:{
      placeholder: '请输入批次',
      maxLength:100
    },
  },
  {
    label:'',
    name:'batchAttrName',
    custom:true
  },
]

// 库存查询(按库位批次库存明细)
export const locationBatchesSearchFiled = (GOODS_QUALITY, ZONE_TEMPERATURE_LAYER_CODE) => [
  {
    label:'仓库',
    name:'warehouseCode',
    custom:true
  },
  {
    label:'货品编码',
    name:'goodsCode',
    type:'input',
    prop:{
      placeholder: '请输入货品编码',
      maxLength:100
    }
  },
  {
    label:'货品名称',
    name:'goodsName',
    type:'input',
    prop:{
      placeholder: '请输入货品名称',
      maxLength:100
    },
  },
  {
    label: '库区',
    name: 'warehouseAreaId',
    custom:true
  },
  {
    label: '库位',
    name: 'locationCode',
    type:'input',
    prop:{
      placeholder: '请输入库位',
      maxLength:100
    },
  },
  {
    label: '货品质量',
    name: 'goodsQuality',
    type:'select',
    prop:{
      placeholder: '请选择货品质量',
      allowClear:true,
      options:GOODS_QUALITY
    },
  },
  {
    label: '批次号',
    name: 'batchNo',
    type:'input',
    prop:{
      placeholder: '请输入批次',
      maxLength:100
    },
  },
  {
    label: '冻结状态',
    name: 'frozenStatus',
    type:'select',
    prop:{
      placeholder: '请选择冻结状态',
      allowClear:true,
      options:formatData(FROZEN_STATUS)
    },
  },
  {
    label:'',
    name:'labelSelect',
    custom:true
  },
  {
    label: '临期预警',
    name: 'warnStatus',
    type: 'select',
    prop:{
      placeholder: '请选择临期预警',
      allowClear:true,
      options:ALERT_OPTIONS
    },
  }, {
    label: '温层',
    name: 'goodsTemperatureLayer',
    type: 'select',
    prop:{
      placeholder: '请选择温层',
      allowClear:true,
      options:ZONE_TEMPERATURE_LAYER_CODE
    },
  }, {
    label: '库存状态',
    name: 'stockQualityStatus',
    type: 'select',
    prop:{
      placeholder: '请选择库存状态',
      allowClear:true,
      options:formatData(STOCK_STATUS)
    },
  },
]

// 库存table(按库位批次库存明细)
export const locationBatchesTableColumns = () => {
  // const attr = cols.map((item) => ({
  //   title: `批属性-${item.fieldName}`,
  //   dataIndex: `batch_${item.humpFieldCode}`,
  //   key: `batch_${item.humpFieldCode}`,
  //   exportProp: item.humpFieldCode,
  //   width: 180,
  //   customRender: (text,record) => record[item.humpFieldCode],
  // }));
  return [
    {
      title: '序号',
      customRender: (text, record, index) => index + 1,
      width: 50,
    },
    {
      title: '仓库编码',
      dataIndex: 'warehouseCode',
      key: 'warehouseCode',
      width: 180,
    },
    {
      title: '仓库名称',
      dataIndex: 'warehouseName',
      key: 'warehouseName',
      width: 180,
    },
    {
      title: '临期预警',
      dataIndex: 'warnStatusDesc',
      key: 'warnStatusDesc',
      scopedSlots: { customRender: 'warnStatusDesc' },
      width: 180,
    },
    {
      title: '库存状态',
      dataIndex: 'stockQualityStatusDesc',
      key: 'stockQualityStatusDesc',
      // customRender: (text) => STOCK_STATUS[text],
      width: 200,
    },
    {
      title: '货品名称',
      dataIndex: 'goodsName',
      key: 'goodsName',
      scopedSlots: { customRender: 'goodsName' },
      width: 180,
    },
    {
      title: '货主货品编码',
      dataIndex: 'shipperGoodsCode',
      key: 'shipperGoodsCode',
      width: 180,
    },
    // {
    //   title: '货品条码(69码)',
    //   dataIndex: 'internationalCode',
    //   key: 'internationalCode',
    //   width: 180,
    // },
    {
      title: '温层',
      dataIndex: 'temperatureLayerName',
      key: 'temperatureLayerName',
      width: 80,
    },
    {
      title: '批次号',
      dataIndex: 'batchNo',
      key: 'batchNo',
      width: 180,
    },
    {
      title: '库区',
      dataIndex: 'warehouseAreaName',
      key: 'warehouseAreaName',
      width: 165,
    },
    {
      title: '库区类型',
      dataIndex: 'warehouseAreaTypeName',
      key: 'warehouseAreaTypeName',
      width: 80,
    },
    {
      title: '库位',
      dataIndex: 'locationCode',
      key: 'locationCode',
      width: 240,
    },
    {
      title: '货品质量',
      dataIndex: 'goodsQuality',
      key: 'goodsQuality',
      width: 120,
    },
    {
      title: '冻结原因',
      dataIndex: 'frozenReason',
      key: 'frozenReason',
      width: 180,
      customRender:(text)=>text || '-'
    },
    {
      title: '冻结状态',
      dataIndex: 'frozenStatusDesc',
      key: 'frozenStatusDesc',
      width: 80,
    },
    {
      title: '默认单位',
      dataIndex: 'defaultUnit',
      key: 'defaultUnit',
      width: 80,
    },
    {
      title: '规格',
      dataIndex: 'goodsSpecifications',
      key: 'goodsSpecifications',
      width: 80,
    },
    {
      title: '换算率',
      dataIndex: 'conversionRate',
      key: 'conversionRate',
      width: 80,
    },
    {
      title: '总库存(默认单位)',
      dataIndex: 'defaultUnitAmount',
      key: 'defaultUnitAmount',
      width: 140,
    },
    {
      title: '总库存(整单位)',
      dataIndex: 'totalBigUnitNum',
      key: 'totalBigUnitNum',
      width: 140,
      customRender: (text,record) => record.totalBigUnitNum + record.bigUnit,
    },
    {
      title: '总库存(零单位)',
      dataIndex: 'totalSmallUnitNum',
      key: 'totalSmallUnitNum',
      width: 140,
      customRender: (text,record) => record.totalSmallUnitNum + record.smallUnit,
    },
    {
      title: '总体积(cm³)',
      dataIndex: 'volume',
      key: 'volume',
      width: 140,
      customRender: (text,record) => record.volume<0.000001?'-':record.volume,
    },
    {
      title: '总重量（kg）',
      dataIndex: 'weight',
      key: 'weight',
      width: 140,
      customRender: (text,record) => record.weight<0.000001?"-":record.weight,
    },
    {
      title: '可用量',
      dataIndex: 'availableNum',
      key: 'availableNum',
      width: 140,
      customRender: (text,record) => (record.availableNum
        ? unitNumber.calculate({ ...record, smallUnitNumber: record.availableNum }).txt : record.availableNum),
    },
    {
      title: '分配量',
      dataIndex: 'lockedNum',
      key: 'lockedNum',
      width: 160,
      customRender: (text,record) => (record.lockedNum
        ? unitNumber.calculate({ ...record, smallUnitNumber: record.lockedNum }).txt : record.lockedNum),
    },
    {
      title: '冻结量',
      dataIndex: 'frozenNum',
      key: 'frozenNum',
      width: 160,
      customRender: (text,record) => (record.lockedNum
        ? unitNumber.calculate({ ...record, smallUnfrozenNumitNumber: record.frozenNum }).txt : record.frozenNum),
    },
    {
      title: '生产日期',
      dataIndex: 'stockProductDate',
      key: 'stockProductDate',
      width: 165,
      // customRender: (text) =>text?moment(text).format('YYYY-MM-DD'):'',
    },
    {
      title: '到期日期',
      dataIndex: 'stockExpireDate',
      key: 'stockExpireDate',
      width: 165,
      // customRender: (text) =>text?moment(text).format('YYYY-MM-DD'):'',
    },
    {
      title: '保质期(天)',
      dataIndex: 'shelfLife',
      key: 'shelfLife',
      width: 120,
    },
    {
      title: '库龄',
      dataIndex: 'stockAge',
      key: 'stockAge',
      width: 80,
    },

    {
      title: '最后操作时间',
      dataIndex: 'updateTime',
      key: 'updateTime',
      width: 160,
      customRender: (text) => text?moment(text).format('YYYY-MM-DD'):''
    },
    {
      title: '最后操作人',
      dataIndex: 'operatorName',
      key: 'operatorName',
      width: 160,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 100,
      scopedSlots: { customRender: 'action' },
      fixed:'right'
    },
  ]
}

export const orderInfoFileds = [
  // {
  //   prop: 'goodsCode',
  //   label: '货品编码:',
  // },
  // {
  //   prop: 'shipperName',
  //   label: '货主:',
  // },
  {
    prop: 'goodsName',
    label: '货品名称:',
  },
  {
    prop: 'shipperGoodsCode',
    label: '货主货品编码:',
  },
  {
    prop: 'batchNo',
    label: '批次号:',
  },
  {
    prop: 'locationCode',
    label: '库位:',
  },
  {
    prop: 'lockedAmount',
    label: '锁定量:',
  },
];
// 任务类型
export const TaskType = {
  PICKING: 'PICKING', // 出库-拣货
  PART_PICKING: 'PART_PICKING', // 出库-分拣
  RECHECKED: 'RECHECKED', // 出库-复核
  GATHER: 'GATHER', // 出库-集货
  LOADING: 'LOADING', // 出库-装车
  TRANSPORT: 'TRANSPORT', // 出库--发运
  MOVE: 'MOVE', // 出库-移动
  ACCEPTANCE: 'ACCEPTANCE', // 入库-验货
  UPPER_SHELF: 'UPPER_SHELF', // 入库-上架
  WAREHOUSING: 'WAREHOUSING', // 入库-入库
  TRANSFER_DOWN: 'TRANSFER_DOWN', // 移库移位-下货
  TRANSFER_UP: 'TRANSFER_UP', // 移库移位-上货
  COUNT: 'COUNT', // 盘点
  RECOUNT: 'RECOUNT', // 双人盘点
  TRANSFER_DIRECT: 'TRANSFER_DIRECT', // 直接移库
  DIFFERENCE_MOVE: 'DIFFERENCE_MOVE', // 差异回库
  ARRIVAL_REGISTRATION: 'ARRIVAL_REGISTRATION', // 入库-到货登记
  QUALITY_INSPECTION: 'QUALITY_INSPECTION', // 入库-车辆质检
  ACCEPT_UNLOADING_GOODS: 'ACCEPT_UNLOADING_GOODS', // 入库-卸货
  DELIVER_QUALITY_INSPECTION: 'DELIVER_QUALITY_INSPECTION', // 出库-质检
  FIRST_COUNT: 'FIRST_COUNT', // 在库-初盘
  REDO_COUNT: 'REDO_COUNT', // 在库-复盘
  ADJUST_REVIEW: 'ADJUST_REVIEW', // 在库-调整审核
  DESTRUCTION: 'DESTRUCTION', // 销毁申请
  TRANSFER_RECHECKED: 'TRANSFER_RECHECKED', // 移库复核
};
export const TaskTypeText = {
  [TaskType.ARRIVAL_REGISTRATION]: '入库-到货登记', // 入库-到货登记
  [TaskType.QUALITY_INSPECTION]: '入库-车辆质检', // 入库-车辆质检
  [TaskType.ACCEPT_UNLOADING_GOODS]: '入库-卸货', // 入库-卸货
  [TaskType.ACCEPTANCE]: '入库-到货验收', // 入库-到货验收
  [TaskType.UPPER_SHELF]: '入库-上架', // 入库-上架
  [TaskType.PICKING]: '出库-拣货', // 出库-拣货
  [TaskType.PART_PICKING]: '出库-分拣', // 出库-分拣
  [TaskType.RECHECKED]: '出库-复核', // 出库-复核
  [TaskType.GATHER]: '出库-集货', // 出库-集货
  [TaskType.LOADING]: '出库-装车', // 出库-装车
  [TaskType.TRANSPORT]: '出库-发运', // 出库--发运
  [TaskType.MOVE]: '出库-移动', // 出库-移动
  [TaskType.WAREHOUSING]: '入库-入库', // 入库-入库
  [TaskType.TRANSFER_DOWN]: '在库-移库下架', // 在库 - 移库下架
  [TaskType.TRANSFER_UP]: '在库-移库上架', // 在库 - 移库上架
  [TaskType.RECOUNT]: '双人盘点', // 双人盘点
  [TaskType.DELIVER_QUALITY_INSPECTION]: '出库-质检', // 出库-质检
  [TaskType.FIRST_COUNT]: '在库-初盘', // 在库-初盘
  [TaskType.REDO_COUNT]: '在库-复盘', // 在库-复盘
  [TaskType.COUNT]: '在库-盘点确认', // 在库-盘点确认
  [TaskType.ADJUST_REVIEW]: '在库-调整审核', // 在库 - 调整审核
  [TaskType.TRANSFER_DIRECT]: '直接移库', // 直接移库
  [TaskType.DIFFERENCE_MOVE]: '差异回库', // 差异回库
};

// 单据类型
export const BillType = {
  STORE: 'STORE',
  MOVE: 'MOVE',
  COUNT: 'COUNT',
  WAVE: 'WAVE',
  TRANSFER: 'TRANSFER',
};

export const BillTypeText = {
  [BillType.STORE]: '入库',
  [BillType.MOVE]: '移动',
  [BillType.COUNT]: '盘点',
  [BillType.WAVE]: '波次',
  [BillType.TRANSFER]: '移库移位',
};
export const tableColumns = [
  {
    title: '任务号',
    dataIndex: 'taskNo',
    key: 'taskNo',
    width:200,
  },
  {
    title: '任务类型',
    // dataIndex: 'taskType',
    // key: 'taskType',
    customRender: (row) => TaskTypeText[row.taskType],
  },
  {
    title: '来源单据类型',
    // dataIndex: 'orderType',
    // key: 'orderType',
    customRender: (row) => BillTypeText[row.orderType],
  },
  {
    title: '来源单据号',
    dataIndex: 'orderNo',
    key: 'orderNo',
    width:200,
  },
  {
    title: '锁定量',
    dataIndex: 'lockedAmountStr',
    key: 'lockedAmountStr',
  },
  {
    title: '锁定时间',
    // dataIndex: 'lockedTime',
    // key: 'lockedTime',
    customRender: (row) =>row.lockedTime?moment(row.lockedTime).format('YYYY-MM-DD'):''
  },
];
